
$(document).ready(function()
{
  //DEB MENU MOBILE CUSTOM

    $(document).on('click', '.dropDownMenu', function()
    {
      if($(this).hasClass('open')){
        $(this).removeClass('open');
        $(this).siblings('.list_item').hide(200); 
        $(this).find('.icoArrDown').css('transform', 'rotate(90deg)');
      }
      else{
        $(this).addClass('open');
        $(this).siblings('.list_item').show(200); 
        $(this).find('.icoArrDown').css('transform', 'rotate(-90deg)');
      }
    });

  //
   $(document).on('click', '.icoCross', function()
    {
      $('.overlay_background').trigger('click');
      $(this).css('transform', 'rotate(360deg)');
    });
    
  //FIN MENU MOBILE CUSTOM
  
  //Page produit - pour les onglet tab-vertical
  //Quando n licque sur un onglet ça ferme les autres
  $(document).on('click', '.toggle-title', function()
  {
    let aAccordeon = $('.toggle-title');
                 
    $.each(aAccordeon, function()
    {
      
      if($(this).find('.toggleLink').attr('aria-expanded') == true)
      {
        $(this).find('.toggleLink').removeClass('collapsed');
        $(this).find('.toggleLink').attr('aria-expanded', true);
        $(this).siblings('.toggle-content:first').removeClass('show');
      }
      else
      {
    	$(this).find('.toggleLink').addClass('collapsed');
      	$(this).find('.toggleLink').attr('aria-expanded', false);
      	$(this).siblings('.toggle-content').removeClass('show');
      }
    });
  });
  
  
  /*
  //See more page description
  $(document).on('click', '.seeMoreDescCollection', function()
  {
    $(this).css('display', 'none').siblings('.descCollectionPage').css('max-height', '100%');
    $('.seeLessDescCollection').css('display', 'block');
    
  });
  $(document).on('click', '.seeLessDescCollection', function()
  {
    $(this).css('display', 'none').siblings('.descCollectionPage').css('max-height', '50px');
    $('.seeMoreDescCollection').css('display', 'none');
  });
  
  */

  //Cart quantity selector
  $(document).on('click', '.minusQty', function() 
  {
    let oQty = $(this).siblings('input');
	let iQty = parseInt(oQty.val());
    if(parseInt(iQty - 1) >= 0)
    {
      oQty.val(iQty - 1);
      oQty.trigger('change');
    }
  });
  
  $(document).on('click', '.plusQty', function() 
  {
    let oQty = $(this).siblings('input');
    let iQty = parseInt(oQty.val());
    if(parseInt(iQty + 1) <= 20)
    {
      oQty.val(iQty + 1);
      oQty.trigger('change');
    }
  });
  
  //EOS Cart quantity selector
  // Fermeture de la popup taille après avoir cliqué sur ADD TO CART
  $('.product-card__button2').on('click', function()
  {
	$(this).closest('.product-card__image').find('.close').trigger('click');
  });
  
  
  $(document).on('mouseover', '.boost-pfs-filter-product-item-inner', function()
  {
    $(this).find('.product-card__button').css('bottom', '0px');
  });
  
  
  $(document).on('mouseleave', '.boost-pfs-filter-product-item-inner', function()
  {
    $(this).find('.product-card__button').css('bottom', '-100px');
  });
  
  
  $(document).on('click', function()
  {
    let idProduct = $(this).closest('.boost-pfs-filter-product-item').attr('data-id');
    
    $('.boost-pfs-minicart-container-inner').find('.progress-bar').html(idProduct);
    
  });
  
  $(document).on('click', '.boost-pfs-addtocart-select-options', function()
  {
    let sTaille = $('.boost-pfs-filter-option-size').find('.boost-pfs-filter-option-item.selected').find('.boost-pfs-filter-option-value').html();   
  	if(sTaille != undefined) reloadSearch($(this).closest('.boost-pfs-filter-product-item-image'), sTaille);
  });
  
  $(document).on('click', '.ctn_title_level_2', function()
  {
    $(this).siblings('.ctn_item_level_2').show(650);
    $(this).closest('.item_level_1').siblings('.item_level_1').hide(50);
    $(this).closest('.item_level_2').siblings('.item_level_2').hide(50);
    $(this).closest('.ss_menu_level_2').siblings('.title_level_1').hide(50);
    $(this).hide();
  });
  
  $(document).on('click', '.ctn_title_back_level_2', function()
  {
    $(this).closest('.ctn_item_level_2').hide(50);
    $(this).closest('.ss_menu_level_2').siblings('.title_level_1').show(650);
    $(this).closest('.item_level_1').siblings('.item_level_1').show(650);
    $(this).closest('.ctn_item_level_2').siblings('.ctn_title_level_2').show(650);
    $(this).closest('.item_level_2').siblings('.item_level_2').show(650);
   
  });
  
  $(document).on('click', '.boost-pfs-quickview-cart-btn', function()
  {
    
    let iBuble = parseInt($('.countPill.cart-quantity').html());
    let iCartItem = parseInt($('[data-cart-count]').html());
    
    function mutate(mutations) {
      
      if(mutations[0].addedNodes[0].textContent.trim() == "Added!")
      {
		theme.Product.prototype._setupSideCart();
      	$('.countPill.cart-quantity').html(iBuble+1);
      	$('[data-cart-count]').html(iCartItem+1);
        this.disconnect();
      }
    }
  
    var observer = new MutationObserver( mutate );
    var config = { characterData: true, attributes: true, childList: true, subtree: true };

    observer.observe($(this)[0], config); 
    
  });
  
  $(document).on('click', '.overlay_background', function()
  {
    //On enlève la classe  pfs qui empêche le scroll
    $('html').removeClass('boost-pfs-body-no-scroll-mini-cart');
  });
                 
    /*
      //Page produit
  if(window.innerWidth > 1024)
  {
      let sHeight = $('.product-single__details').height();
      $('#shopify-section-tab-vertical').css('top', sHeight+'px');
  }
      */
});

function reloadSearch(a, sTaille)
{
  setTimeout(function()
  {
     if(a.find('.boost-pfs-select-option-wrapper').length > 0)
     {
       a.find('.boost-pfs-select-option-wrapper').find('.boost-pfs-quickview-cart-form').find('input').removeAttr('checked');
       a.find('.boost-pfs-select-option-wrapper').find('.boost-pfs-quickview-cart-form').find('input[value="' + sTaille + '"]').prop('checked', 'checked');
     }
     else reloadSearch(a, sTaille);
  },50);
}